export default __webpack_public_path__ + "assets/media/films.260ebcd2.png";